"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoxPrice = exports.getBoxBlockedOutPrice = void 0;
var getBoxBlockedOutPrice = function (box, priceCategory) {
    if (!priceCategory)
        return box.price.blockedOutOneShot;
    var pc = priceCategory.replace(/^price/, '').replace('Enterprise', '');
    var key = "blockedOut".concat(pc.charAt(0).toUpperCase() + pc.slice(1));
    return box.price[key];
};
exports.getBoxBlockedOutPrice = getBoxBlockedOutPrice;
var getBoxPrice = function (box, priceCategory) {
    if (!priceCategory)
        return box.price.oneShot;
    var pc = priceCategory.replace(/^price/, '').replace(/^./, function (c) { return c.toLowerCase(); });
    return box.price[pc] || box.price.oneShot;
};
exports.getBoxPrice = getBoxPrice;
exports.default = { getBoxBlockedOutPrice: exports.getBoxBlockedOutPrice, getBoxPrice: exports.getBoxPrice };
//# sourceMappingURL=BoxPrices.js.map